var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.414 2H6C4.897 2 4 2.898 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V6.586L15.414 2ZM7 12H15V14H7V12ZM17 18H7V16H17V18ZM14 8V3L19 8H14Z",
    fill: "#FFB300"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 8,
    fill: "#FFB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29017 18V17.5437L10.1048 14.9975H8.28662V14.3636H11.0707V14.82L9.25431 17.3661H11.0743V18H8.29017ZM12.433 14.3636V18H11.6642V14.3636H12.433ZM13.0656 18V14.3636H14.5002C14.776 14.3636 15.011 14.4163 15.2051 14.5217C15.3993 14.6258 15.5472 14.7708 15.649 14.9567C15.752 15.1413 15.8035 15.3544 15.8035 15.5959C15.8035 15.8374 15.7514 16.0504 15.6472 16.2351C15.5431 16.4197 15.3921 16.5636 15.1945 16.6665C14.998 16.7695 14.76 16.821 14.4807 16.821H13.5663V16.2049H14.3564C14.5044 16.2049 14.6263 16.1795 14.7222 16.1286C14.8192 16.0765 14.8914 16.0049 14.9388 15.9137C14.9873 15.8214 15.0116 15.7154 15.0116 15.5959C15.0116 15.4751 14.9873 15.3698 14.9388 15.2798C14.8914 15.1887 14.8192 15.1183 14.7222 15.0685C14.6251 15.0176 14.502 14.9922 14.3528 14.9922H13.8344V18H13.0656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/IconZIP.b318015b.svg";
export { ForwardRef as ReactComponent };